exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes blinking{0%,to{opacity:0}50%{opacity:1}}@keyframes right-left{0%{left:70%}50%{left:-50%}to{left:100%}}level-prologue .story-end{background-color:#fff8dc;border:2px dashed #575d6b;padding:10px 15px}level-prologue .story-end.story-end-2{width:85%}level-prologue .skip-button{position:absolute;bottom:20px;right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/autoprefixer-loader?{browsers:['last 2 version']}!../~/sass-loader!./components/levels/levelPrologue/levelPrologue.scss
// module id = 79
// module chunks = 0